import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { GatewayService } from 'src/app/gateway.service';
import { debounceTime, tap, switchMap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-catalogocampana',
  templateUrl: './catalogocampana.component.html',
  styleUrls: ['./catalogocampana.component.scss']
})
export class CatalogocampanaComponent implements OnInit {

  public filteredOptions: Observable<string[]>;
  public isLoadingCampana: boolean = false;
  valido: boolean = true;

  grupoVal = new FormGroup({
    campana: new FormControl(''),
  });

  constructor(
    private gateway: GatewayService,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit() {

    this.loadCampana();
    this.grupoVal
      .get('campana')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoadingCampana = true),
        switchMap(value =>
          this.gateway.get('getcampana', { NUM_PAGINA: 0, FILTRO: value, NUM_ELEMENTOS: 5, IDPAIS: 5, })
            .then((result: any) => {
              this.filteredOptions = result.rows;
              this.isLoadingCampana = false;
            }
            ).catch(function (e) {
            })
        )
      )
      .subscribe(campana => {
      }
      );
  }

  public displayFn(campana?: any): string | undefined {
    if (campana) { return campana.nombre }
  }

  public loadCampana() {
    this.gateway.get('getcampana', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 5, IDPAIS: 5 }).then((result: any) => {
      this.filteredOptions = result.rows;
    }
    ).catch(function (e) {
    });
  }

  selectcampana() {
    if (this.grupoVal.controls.campana.value.idcampana) {
      this.valido = true;
    } else {
      this.valido = false;
    }
  }

  // descargarcampana() {
  //   let clientes = [];
  //   let asesores = [];
  //   this.spinner.show();
  //   this.gateway.get('exportarlista', { IDCAMPANA: this.grupoVal.controls.campana.value.idcampana }).then(
  //     (data: any) => {
  //       if (data.rowCount > 0) {
  //         clientes = data.rows;
  //         this.gateway.get('agentecampanalite', { IDCAMPANA: this.grupoVal.controls.campana.value.idcampana }).then(
  //           (data: any) => {
  //             if (data.rowCount > 0) {
  //               asesores = data.rows;
  //               let auxcliente = [];
  //               clientes.map(cliente => {
  //                 auxcliente.push({ nombre: cliente.nombre, telefono: cliente.telefono, 'correo asesor': '' });
  //               });
  //               let auxasesor = [];
  //               asesores.map(asesor => {
  //                 auxasesor.push({ nombre: asesor.nombre + ' ' + asesor.apellido, correo: asesor.correo });
  //               });

  //               var keys = Object.keys(auxcliente[0]);
  //               console.log(keys);
  //               // auxcliente.unshift(keys);
  //               const fileName = 'Campana' + this.grupoVal.controls.campana.value.nombre + '-' + Date.now();
  //               const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //               const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(auxcliente);

  //               const wsasesor: XLSX.WorkSheet = XLSX.utils.json_to_sheet(auxasesor);

  //               XLSX.utils.book_append_sheet(wb, ws);
  //               XLSX.utils.book_append_sheet(wb, wsasesor);

  //               const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
  //               saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");

  //             } else {
  //               this.snackbar.open('No hay agentes para esta campaña.', 'Cerrar', { duration: 3000, });
  //               this.spinner.hide();
  //             }
  //           });

  //         this.spinner.hide();
  //       } else {
  //         this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
  //         this.spinner.hide();
  //       }
  //     }
  //   );
  // }

  descargarcampana() {
    this.spinner.show();
    this.gateway.get('exportarlistacount', { IDCAMPANA: this.grupoVal.controls.campana.value.idcampana }).then(
      (data: any) => {
        if (data.rows[0].cantidad > 0) {
          this.prepararinformacion(data.rows[0].cantidad, 0, null);
        } else {
          this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
          this.spinner.hide();
        }
      }
    );
  }

  prepararinformacion(count, index, datacliente) {
    this.gateway.get('exportarlistalote', { IDCAMPANA: this.grupoVal.controls.campana.value.idcampana, LIMIT: 100, OFFSET: index }).then(
      (result: any) => {
        if (datacliente) {
          datacliente = datacliente.concat(result.rows)
        } else {
          datacliente = result.rows;
        }
        let control = index + 100;
        if (control <= count) {
          this.prepararinformacion(count, control, datacliente);
        } else {
          this.descargarexcel(datacliente);
        }
      }
    );
  }

  descargarexcel(ctr) {
    let asesores=[];
    this.gateway.get('agentecampanalite', { IDCAMPANA: this.grupoVal.controls.campana.value.idcampana }).then(
      (data: any) => {
        if (data.rowCount > 0) {
          asesores = data.rows;
          let auxcliente = [];
          ctr.map(cliente => {
            auxcliente.push({ nombre: cliente.nombre, telefono: cliente.telefono, 'asesor': '' });
          });
          let auxasesor = [];
          asesores.map(asesor => {
            auxasesor.push({ nombre: asesor.nombre + ' ' + asesor.apellido, usuario: asesor.correo });
          });

          const fileName = 'Campana' + this.grupoVal.controls.campana.value.nombre + '-' + Date.now();
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(auxcliente);

          const wsasesor: XLSX.WorkSheet = XLSX.utils.json_to_sheet(auxasesor);

          XLSX.utils.book_append_sheet(wb, ws);
          XLSX.utils.book_append_sheet(wb, wsasesor);

          const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
          saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
          this.spinner.hide();

        } else {
          this.snackbar.open('No hay agentes para esta campaña.', 'Cerrar', { duration: 3000, });
          this.spinner.hide();
        }
      });

  }

  startupload() {
    document.getElementById("uploadfile").click();
  }

  onFileChange(evt: any) {
    let catalogo = { IDCAMPANA: this.grupoVal.controls.campana.value.idcampana, LISTA: [] };
    this.spinner.show();
    let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

    /*    this.openclose=false;*/
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      (<HTMLInputElement>document.getElementById('uploadfile')).value = null;
      let csv = [];
      const flag = dataexcel[0];
      let bandera: number = 0;
      if ((flag[0] === 'nombre' ||flag[0] === 'NOMBRE') && (flag[1] === 'telefono' || flag[1] === 'TELEFONO') && 
        (flag[2] === 'asesor') || flag[2] === 'ASESOR') {
        dataexcel.forEach((value) => {
          if ((value[0] !== 'nombre' || value[0] !== 'NOMBRE') && (value[1] !== 'telefono' || value[1] !== 'TELEFONO') && (value[2] !== 'asesor' || value[2] !== 'ASESOR')) {
            catalogo.LISTA.push({ TELEFONO: value[1], CORREO: value[2] });
          }
        });
        this.loadlistxls(catalogo, 0);
      } else {
        this.snackbar.open('Formato de archivo no válido, porfavor intente con otro archivo.', 'CERRAR', { duration: 6000 });
      }
      this.spinner.hide();
    };
    reader.readAsBinaryString(target.files[0]);
  }

  loadlistxls(data, cantidad) {
    this.spinner.show();
    let auxarr = [];
    auxarr = data.LISTA.slice(cantidad, cantidad + 300);
    this.gateway.save('cargacatalogo', { IDCAMPANA: this.grupoVal.controls.campana.value.idcampana, LISTA: auxarr }).then(
      res => {
        if ((cantidad + 300) < data.LISTA.length) {
          this.loadlistxls(data, cantidad + 300);
        } else {
          this.spinner.hide();
          this.snackbar.open('Clientes cargados con éxito.', 'Cerrar', { duration: 3000, });
        }
      },
      err => {
        this.snackbar.open('Los clientes no han sido cargados, intente nuevamente.', 'Cerrar', { duration: 3000, });
        this.spinner.hide();
        // Error handled silently
      }
    );
  }

}

